export default {
  landing: [],
  name: '',
  title: '',
  pageCategory: '',
  pageType: '',
  activeId: null,
  currentView: 'lg',
  published: null,
  panelCopied: '',
  currentNavBar: 'Landing',
}
